import React, { useEffect, useState } from "react";
import styles from "./FileCard.module.css";
import MoreButton from "../../Molecules/Custom/CardMoreButton";
import exportICon from "../../../assets/Imagess/exportIcon.svg";
import deleteicon from "../../../assets/Imagess/deleteicon.svg";
import moreicon from "../../../assets/Imagess/more-dotes.svg";

import IDImage from "../../../assets/Imagess/IDImage.svg";
import PassportImage from "../../../assets/Imagess/PassportImage.svg";
import FamilyImage from "../../../assets/Imagess/FamilyImage.svg";
import CVImage from "../../../assets/Imagess/CVImage.svg";
import CheckBox from "../Inputs/CheckBox";
import PopOver from "../../Molecules/Custom/PopOver/PopOver";

const UsersTable = ({
  file,
  title,
  id,
  type,
  setShowAttachModal,
  handleDownloadFile,
  handleDeleteFile,
  fileId,
  setFileId,
  setContentType,
  ContentType,
  contentType,
  selectedFiles,
  setSelectedFiles,
  handleDeleteClick,
}) => {
  const [isReady, setIsReady] = useState(false);
  const [selected, setSelected] = useState([]);

  const handleOnSelect = (documentId) => {
    if (selectedFiles.includes(documentId)) {
      setSelectedFiles(selectedFiles.filter((id) => id !== documentId));
    } else {
      setSelectedFiles([...selectedFiles, documentId]);
      console.log("jbjbk", selectedFiles);
    }
  };

  // useEffect(() => {
  //   if (fileId && contentType && isReady) {
  //     handleDownloadFile(contentType);
  //   }
  // }, [fileId, contentType, isReady,handleDownloadFile]);

  // const handleDownloadClick = (id) => {
  //   setFileId(id);
  //   setContentType(ContentType);
  //   setIsReady(true);
  // };
  console.log("scnksdn", file);

  return (
    <div className={`${styles["fileCard"]}`} title={title}>
      {" "}
      <img
        alt='PHo'
        src={
          type === "Emirates Id"
            ? IDImage
            : type === "CV"
            ? CVImage
            : type === "Family Book"
            ? FamilyImage
            : PassportImage
        }
        className={styles["fileCardImg"]}
      />
      <h3>{title.length > 15 ? title.substring(0, 15) + ".." : title}</h3>
      <h6>{type}</h6>
      <div className={`${styles["expand"]}`}>
        {" "}
        <CheckBox
          value={selectedFiles.includes(id)}
          onChange={() => handleOnSelect(id)}
        />
      </div>
      <div className={`${styles["more"]}`} id='MoreButton'>
        <MoreButton
          icon={moreicon}
          imgHeight={25}
          imgWidth={25}
          top={-20}
          right={11}
          // width={150}
        >
          <PopOver
            stop
            info={[
              {
                title: "Download",
                icon: exportICon,
                handleFunction: () => handleDownloadFile(id),
              },
              {
                title: "Delete",
                icon: deleteicon,
                handleFunction: () => handleDeleteClick(id),
              },
            ]}
          />
        </MoreButton>
      </div>
    </div>
  );
};

export default UsersTable;
